import React from 'react';
import { createPortal } from 'react-dom';
import { motion } from 'framer-motion';
import { FaBolt } from 'react-icons/fa';

/**
 * Menú de acciones rápidas renderizado como portal para escapar del overflow de la tabla.
 *
 * Props:
 * - anchorRect: resultado de getBoundingClientRect() del botón trigger
 * - children: items del menú
 */
const QuickActionsMenu = ({ anchorRect, children }) => {
    if (!anchorRect) return null;

    // Altura estimada: cabecera + ~40px por accion (antes era fija y los menus
    // largos se salian por debajo de la pantalla)
    const menuHeight = 44 + React.Children.toArray(children).length * 40;
    const viewportHeight = window.innerHeight;
    const spaceBelow = viewportHeight - anchorRect.bottom;
    const openAbove = spaceBelow < menuHeight + 10;

    const menuWidth = 220; // min-w-[220px] del CSS
    const style = {
        top: openAbove ? Math.max(8, anchorRect.top - menuHeight - 4) : anchorRect.bottom + 4,
        right: document.documentElement.clientWidth - anchorRect.right,
    };

    return createPortal(
        <motion.div
            className="quick-actions-menu"
            style={style}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.12 }}
        >
            <div className="quick-actions-header">
                <FaBolt className="header-icon" />
                <span>Acciones Rápidas</span>
            </div>
            {children}
        </motion.div>,
        document.body
    );
};

export default QuickActionsMenu;
